import React, { useContext, useState } from "react";

import DivRow from "../controls/DivRow";
import DropDown from "../controlsNR/DropDown";
import Input from "../controlsNR/InputNR";
import SwitchButton from "../controlsNR/SwitchButtonNR";
import {
  DataContextReclamo
} from "../../context/DataContextReclamo";
import Datetime from "../controlsNR/DateTime";

const Step2 = () => {
 // const  HoraPattern = "^(1[0-2]|[1-9])$";
  const  HoraPattern = "^(0?[1-9]|1[0-2])$";
  const DiaPattern = "^(0?[1-9]|[1-2][0-9]|3[0-1])$";
  const TiempoPattern = "\s?(am|pm|AM|PM)";
  const MinutoPattern = "^(0?[0-9]|[1-5][0-9])$";
  const AñoPattern = "^20((1[1-9])|([2-9][0-9]))$"

  const lstDias = [];
  const lstMes = [];
  const lstAnios = [];
  const today = new Date();
  const year = today.getFullYear(); // returns 95   


  for (var i = 1; i <= 31; i++) {
    var dia = { value: i, text: i};
    lstDias.push(dia);
 }

 for (var i = 1; i <= 12; i++) {
  var mes = { value: i, text: i};
  lstMes.push(mes);
}

for (var i = year ; i >= year - 3 ; i--) {
  var anio = { value: i, text: i};
  lstAnios.push(anio);
}

  const { tramite, setTramite, changeHandler } = useContext(DataContextReclamo);

  const handleChange = (e) =>
    setTramite({ ...tramite, [e.target.name]: e.target.value });

    

  return (
    <div className="step">
      <DivRow width="100%" className="date">
        <Datetime isrequired label="Fecha siniestro*" value={tramite.fechaSiniestro} onChange={date => setTramite({ ...tramite, fechaSiniestro: date })}/> 
        <Datetime isrequired label="Hora siniestro*" type="time" value={tramite.horaSiniestro} onChange={time => setTramite({ ...tramite, horaSiniestro: time })}/> 
       
        <Input
          type="textarea"
          classNameInput="sg-input-area-nr"
          label="Dirección del Siniestro*"
          field="direccionSiniestro"
          value={tramite.direccionSiniestro}
          onChange={handleChange}
          classLabel = "labelComponent"
          
        />
        <Input
          type="textarea"
          classNameInput="sg-input-area-nr"
          label="Descripción del siniestro*"
          field="descripcionSiniestro"
          value={tramite.descripcionSiniestro}
          onChange={handleChange}
          classLabel = "labelComponent"
          
        />

<SwitchButton
          label="¿Se presentó la Policía de Tránsito?*"
          value={tramite.sePresentoPoliciaTransito}
          onClick={(value) => setTramite({ ...tramite, sePresentoPoliciaTransito: value })}
          si="Si"
          no="No"
          className="sg-input-field-nr"
          name={tramite.sePresentoPoliciaTransito}
          classLabel="labelComponent"
        />

<SwitchButton
          label="¿Llamó al servicio de Asistencia?*"
          value={tramite.llamoServicioAsistencia}
          onClick={(value) => setTramite({ ...tramite, llamoServicioAsistencia: value })}
          si="Si"
          no="No"
          className="sg-input-field-nr"
          name={tramite.llamoServicioAsistencia}
          classLabel="labelComponent"
        />

<SwitchButton
          label="¿Hubo propiedad dañada?*"
          value={tramite.huboPropiedadDañada}
          onClick={(value) => setTramite({ ...tramite, huboPropiedadDañada: value })}
          si="Si"
          no="No"
          className="sg-input-field-nr"
          name={tramite.huboPropiedadDañada}
          classLabel="labelComponent"
        />

<SwitchButton
          label="¿Resultaron terceros lesionados?*"
          value={tramite.resultaronTercerosLesionados}
          onClick={(value) => setTramite({ ...tramite, resultaronTercerosLesionados: value })}
          si="Si"
          no="No"
          className="sg-input-field-nr"
          name={tramite.resultaronTercerosLesionados}
          classLabel="labelComponent"
        />



      </DivRow>
      
    </div>
  );
};
export default Step2;
